import { OreButton, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { CashbackAutoEnrollmentTranslation } from '../autoEnrollmentTranslation'
import { useTranslation } from 'react-i18next'
import ShuffleImg from '@/Shared/ui/assets/shuffle.svg'
import { useCashbackAutoEnrollmentController } from '../hooks'

export const CashbackAutoenrollmentContainer = (): JSX.Element => {
  const {initCashbackAutoEnrollmentAcceptance} = useCashbackAutoEnrollmentController()
  const {t} = useTranslation()

  return (
    <OreStack placeItems='center' placeContent='center' space='xlarge'>
      <OreStack placeContent='stretch' space='small'>
        <OreHeading as="h1" align='center' size="title-sm">
          {t(CashbackAutoEnrollmentTranslation.pageTitle)}
        </OreHeading>
        <div style={{maxWidth: 602}}>
          <OreStack space='xsmall' placeContent='stretch'>
            <OreText align='center' size='text-md' tone='neutral-800'>{t(CashbackAutoEnrollmentTranslation.instructions)}</OreText>
            <OreText align='center' size='text-md' tone='neutral-800'>{t(CashbackAutoEnrollmentTranslation.instructions2)}</OreText>
          </OreStack>
        </div>
      </OreStack>
      <img src={ShuffleImg} alt="shuffle" width={150} height={150} />
      <OreButton 
        category='primary'
        onClick={initCashbackAutoEnrollmentAcceptance}
      >
        {t(CashbackAutoEnrollmentTranslation.button.continue)}
      </OreButton>
    </OreStack>
  )
}
